<template lang="pug">
  .component-create-entity-button
    ModalReveal(:ref="`maintenance-${_uid}`", :value="open")
      template(v-if="!open" )
        button.button.success(slot="trigger", v-if="request") Complete

      h2 Complete Intervention request IR{{request.id}}?

      template(v-if="request.linked_requests.length" )
        label Complete linked requests?
        input-switch(v-model="body.complete_all" )

      ActionButton(:action="save", slot="footer" ) Save
      button.button.alert.float-right(slot="footer", @click="$refs[`maintenance-${_uid}`].close()") Cancel

</template>

<script>
import DatePicker from '../../components/structure/DatePicker'
import ModalReveal from '../../components/structure/foundation/ModalReveal'
import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
import MaggieHelper from '../../maggieHelper'
import ActionButton from '../../components/structure/ui/ActionButton'
import SelectizeVehicle from "../../components/structure/ui/lists/selectize/SelectizeVehicle.vue";
import InterventionRequestForm from "../../components/structure/forms/InterventionRequestForm.vue";
import {EventBus} from "../../eventBus";
import MaintenanceRequestList from "./MaintenanceRequestList.vue";
import Vehicle from 'components/backoffice/Vehicle'
import CreateInterventionRequestReveal from "./CreateInterventionRequestReveal.vue";
import {mapState} from "vuex";
import CreateSubInterventionRequestReveal from "./CreateSubInterventionRequestReveal.vue";
import InputSwitch from "../../components/structure/ui/InputSwitch.vue";

export default {
  name: 'CompleteInterventionRequestReveal',
  components: {
    InputSwitch,
    CreateSubInterventionRequestReveal,
    InterventionRequestReveal: CreateInterventionRequestReveal,
    Vehicle,
    MaintenanceRequestList,
    InterventionRequestForm,
    SelectizeVehicle,
    ActionButton,
    ModalReveal,
    DatePicker
  },
  data() {
    return {
      body: {
        complete_all: false
      }
    }
  },
  created() {

  },
  methods: {
    save() {
      return KeplerBackofficeSdk.maintenanceRequest.select(this.request).complete(this.body, () => {
        MaggieHelper.notification('', 'maintenance request completed')
        EventBus.$emit('reload-list')
        EventBus.$emit('close-modal')
      })
    }
  },
  computed: {
    ...mapState({
      configuration: state => state.configuration,
    }),

  },
  props: {
    request: null,
    open: false
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CompleteInterventionRequestReveal.vue?59da5a73